export enum AcceptorType {
	Department = "Department",
	Person = "Person"
}
